import styled from "styled-components";

import { Flex } from "../../style";
import { colors, fonts, sizes } from "../../variables";

export const Container = styled(Flex)`
  display: ${({ show }) => (show ? "flex" : "none")};
  background-color: white;
  padding: ${sizes.sm} ${sizes.xl3};
  justify-content: space-between;
  align-items: center;

  .mobile-menu {
    display: none;
  }

  .desktop-menu {
    display: flex;
  }

  @media screen and (max-width: 768px) {
    font-size: ${fonts.sm};
    .desktop-menu {
      display: none;
    }

    .mobile-menu {
      display: flex;
    }
  }
`;

export const CtaButton = styled(Flex)`
  padding: ${sizes.xs2} ${sizes.xs};
  cursor: pointer;
  align-items: center;
  border: 1px solid ${colors.primary};
  border-radius: ${({ radius }) => radius || sizes.xs2};
  background-color: ${colors.secondary};
  margin-top: ${({ mt }) => mt};

  &:hover {
    transform: scale(1.025);
  }
`;
